module.exports = __webpack_public_path__ + "static/media/electro.e1db293f.svg";